// Chart js
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

function createCharts(){
    if(!$('.chart-container').length){
        return;
    }

    $('.chart-container').each(function(){
        let labels = $(this).data('labels');
        let values = $(this).data('values');

        let canvas = $(`<canvas></canvas>`);
        let container = $(this);

        container.append(canvas);
        const ctx = canvas[0].getContext('2d');

        new Chart(ctx, {
            type: 'pie',
            data: {
                labels: labels,
                datasets: [{
                    data: values
                }]
            }
        });
    });
}

function preparePlanningExport(){
    $('#export-planning').click(function(e){
        $(this).attr('disabled', true);
        $('body').addClass('loading');

        // Get link to the pdf generator
        let form = $(this).parents('form');
        let href = $(this).data('href');

        let chartsData = {};

        // Create images of charts to add in the pdf
        if($('#planning-charts-for-pdf-container > div').length){
            $('#planning-charts-for-pdf-container').removeClass('d-none');

            $('#planning-charts-for-pdf-container > div').each(function(){
                let pastorId = $(this).data('pastor-id');

                let labels = $(this).data('labels');
                let values = $(this).data('values');
                let total = values.reduce((sum, value) => sum + value, 0);
                let valuesPercentage = values.map(value => (value / total) * 100);

                let canvas = $(`<canvas></canvas>`);
                let container = $(this);

                container.append(canvas);
                const ctx = canvas[0].getContext('2d');

                let chart = new Chart(ctx, {
                    plugins: [ChartDataLabels],
                    type: 'pie',
                    data: {
                        labels: labels,
                        datasets: [{
                            data: values
                        }]
                    },
                    options: {
                        animation: {
                            duration: 0
                        },
                        plugins: {
                            legend: {
                                labels: {
                                    font: {
                                        size: 20
                                    }
                                }
                            },
                            datalabels: {
                                color: '#333',
                                font: {
                                    size: 30,
                                    weight: 'bold'
                                },
                                formatter: (value, context) => {
                                    if (value === 0 || valuesPercentage[context.dataIndex] === 0) {
                                        return '';
                                    }
                                    if (valuesPercentage[context.dataIndex] < 2) {
                                        return `${Math.round(value)} (${Math.round(valuesPercentage[context.dataIndex])}%)`;
                                    }
                                    return `${Math.round(value)} (${Math.round(valuesPercentage[context.dataIndex])}%)`;
                                },
                                backgroundColor: '#fff',
                                borderRadius: 4,
                                padding: 2,
                                anchor: 'end',
                                align: 'start',
                                offset: 15
                            }
                        }
                    }
                });

                let chartImage = chart.toBase64Image();

                chartsData[`pastor_${pastorId}`] = {
                    pastorId: pastorId,
                    chartImage: chartImage,
                };
            });

            $('#planning-charts-for-pdf-container').addClass('d-none');
        }

        chartsData = JSON.stringify(chartsData);
        $('#charts-input-field').val(chartsData);

        form.submit();

        //$('#export-planning').attr('disabled', false);
        //$('body').removeClass('loading');
    })
}

const init = () => {
    $(document).ready(function() {
        createCharts();

        preparePlanningExport();
    });
}

export default init;
